module.exports = __webpack_public_path__ + "img/Grimeland.7895c620.jpeg";